module.exports = __webpack_public_path__ + "img/delete-circle.a6bcb029.png";